exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sc-tooltip-container[data-v-81766006]{position:relative}.sc-tooltip-text[data-v-81766006]{position:absolute;color:#2c3e50;background-color:#f2fae8;padding:5px 10px;text-align:left;border:1px solid #f2fae8;cursor:pointer;z-index:2}.sc-tooltip-icon[data-v-81766006]{color:#2c3e50;cursor:pointer;display:inline-block}.sc-tooltip-icon .material-icons[data-v-81766006]{font-size:18px}.sc-tooltip-icon-active[data-v-81766006]{color:#f2fae8}", ""]);

// exports
